import React from 'react';
import PropTypes from 'prop-types';
import { translate as t } from 'admin-on-rest';

import {
  Card,
  CardHeader,
  Tabs,
  Tab,
  Divider,
  TextField,
} from 'material-ui';
import Warning from 'material-ui/svg-icons/alert/warning';
import { orange500 } from 'material-ui/styles/colors';

import { compose } from 'recompose';
import RichTextInput from '../../inputs/RichTextInput';

const styles = {
  // wrapper: { padding: '1em 0' },
  tabContent: { padding: '0.3em 1em 1em 1em' },
  headline: {
    fontSize: 24,
    paddingTop: 16,
    marginBottom: 12,
    fontWeight: 400,
  },
  icon: { margin: '-2px 0 0 3px', width: '16px', height: '16px' },
  tabText: { display: 'flex', flexDirection: 'row', alignItems: 'center' },
};

const locales = [
  { id: 'sv', name: 'Swedish' },
  { id: 'en', name: 'English' },
  { id: 'nb', name: 'Norwegian' },
  { id: 'da', name: 'Danish' },
  { id: 'fi', name: 'Finnish' },
  { id: 'de', name: 'German' },
  // { id: 'es', name: 'Spanish' },
];

export class TranslatableInput extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  componentDidMount = () => {
    // this.hydrateMarkets(this.props);
    this.hydrateMarkets(this.props.values);
  }

  // shouldComponentUpdate = ({ source, record }) => this.props.source.length < source.length || !equal(this.props.record[source], record[source]);

  // componentWillUpdate = (nextProps) => {
  //   this.hydrateMarkets(nextProps);
  // }

  // To show the markets values in the proper tabs we need to hydrate the empty markets in the record state.
  // To do this we must call hydrateMarkets in both componentDidMount to do it on initial load when going into
  // a product via the product list and in componentWillUpdate to do it when you reload the page or come in
  // to a product via an already rendered list... it might be slightly confusing.
  hydrateMarkets = (value) => {
    const newValue = locales.map((locale) => {
      const val = value ? value.find((item) => item.lang === locale.id) : '';
      return { lang: locale.id, content: val ? val.content : '' };
    });

    this.setState({ newValue });
  };

  handleOnChange = (val) => {
    const { newValue } = this.state;
    const value = [...newValue];
    const result = value.map((item) => {
      if (item.lang === val.lang) {
        return { lang: val.lang, content: val.content };
      }
      return item;
    });
    this.setState({ newValue: result }, () => this.props.onChange(result));
  }

  render() {
    const { label } = this.props;
    const { newValue } = this.state;
    return (
      <div style={styles.wrapper}>
        <Card>
          { label && <CardHeader title={label} />}
          <Divider />
          <Tabs className="tabs">
            {locales.map((tab, index) => (
              <Tab
                className="tab"
                key={tab.name}
                label={
                  <span style={styles.tabText}>
                    <span>{tab.name}</span>
                    {newValue && newValue[index].content ? null : <Warning style={styles.icon} color={orange500} />}
                  </span>
                }
              >
                <div style={styles.tabContent}>
                  <InputType {...this.props} tab={tab} value={newValue ? newValue[index].content : ''} handleOnChange={this.handleOnChange} />
                </div>
              </Tab>
            ))
            }
          </Tabs>
        </Card>
      </div>
    );
  }
}

const InputType = ({ id, options = {}, tab, value, handleOnChange }) => (
  <React.Fragment>
    {options && options.multiline ?
      <RichTextInput
        id={`${id}-${tab.name}`}
        options={{ ...options,
          config: {
            height: 150,
            menubar: 'insert',
            convert_urls: false,
            toolbar: 'formatselect | bold italic | link image | code',
          },
        }}
        input={{
          onChange: (val) => handleOnChange({ lang: tab.id, content: val }),
          value,
        }}
      /> : (
        <TextField
          id={`${id}-${tab.name}`}
          name="text"
          value={value && value}
          onChange={(e) => handleOnChange({ lang: tab.id, content: e.target.value })}
          fullWidth
        />
      )}
  </React.Fragment>
);

TranslatableInput.propTypes = {
  source: PropTypes.string,
  multiline: PropTypes.bool,
};

const enhance = compose(
  t
);

export default enhance(TranslatableInput);
